<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="v3-moment-dialog">
  <div class="v3-moment-dialog__header">
    <div class="v3-moment-dialog__profile">
      <ptl-profile-image [userSummary]="userDetailsData$ | async" class="v3-moment-dialog__avatar"> </ptl-profile-image>
      <div class="v3-moment-dialog__user-info">
        <h2 class="v3-moment-dialog__user-name">{{ (userDetailsData$ | async)?.firstName }} {{ (userDetailsData$ | async)?.lastName }}</h2>
      </div>
    </div>
    <ptl-new-moment-expand-btn (changeDialogSizeMode)="changeDialogSizeMode($event)"></ptl-new-moment-expand-btn>
  </div>

  <div class="v3-moment-dialog__body">
    <div class="v3-moment-dialog__content">
      <div class="v3-moment-dialog__editor">
        <ptl-editor
          class="no-outline"
          role="group"
          [placeholder]="'translations.shareYourThoughts' | transloco"
          [title]="'translations.shareYourThoughts' | transloco"
          [content]="moment?.content"
          [bytePlaceholder]="true"
          (contentUpdate)="onContentUpdate($event)"
          (contentRemoval)="onContentRemoval($event)"
          (contentCreated)="onContentCreation($event)"
        >
        </ptl-editor>
      </div>

      <!-- <div class="v3-moment-dialog__reactions"> // Temporary removed reactions
        <button class="v3-moment-dialog__emoji-btn">😊</button>
      </div> -->

      <div class="v3-moment-dialog__actions">
        <div class="v3-moment-dialog__actions-left">
          <button class="v3-moment-dialog__action-btn" [matTooltip]="'translations.global.button.rewriteWithAI' | transloco">
            <mat-icon>auto_fix_high</mat-icon>
            {{ 'translations.global.button.rewriteWithAI' | transloco }}
          </button>

          <button
            class="v3-moment-dialog__action-btn v3-moment-dialog__action-btn--icon"
            [matTooltip]="'translations.global.button.attachFile' | transloco"
            (click)="openFileUploadDialog('DOCUMENT')"
          >
            <mat-icon>attach_file</mat-icon>
          </button>

          <button
            class="v3-moment-dialog__action-btn v3-moment-dialog__action-btn--icon"
            [matTooltip]="'translations.global.button.addPhoto' | transloco"
            (click)="onAddPhoto()"
          >
            <mat-icon>photo_camera</mat-icon>
          </button>

          <button
            class="v3-moment-dialog__action-btn v3-moment-dialog__action-btn--icon"
            [matTooltip]="'translations.global.button.addLink' | transloco"
            (click)="onAddLink()"
          >
            <mat-icon>link</mat-icon>
          </button>

          <button
            class="v3-moment-dialog__action-btn v3-moment-dialog__action-btn--icon"
            [matTooltip]="'translations.global.button.addVideo' | transloco"
            (click)="openFileUploadDialog('STREAM_VIDEO')"
          >
            <mat-icon>videocam</mat-icon>
          </button>

          <button
            class="v3-moment-dialog__action-btn v3-moment-dialog__action-btn--icon"
            [matTooltip]="'translations.global.button.recordAudio' | transloco"
            (click)="openFileUploadDialog('AUDIO')"
          >
            <mat-icon>mic</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="v3-moment-dialog__privacy-section">
    <div class="v3-moment-dialog__privacy-toggle">
      <span class="v3-moment-dialog__privacy-label">
        {{ 'translations.global.button.post' | transloco }}
      </span>
      <div class="toggle-container">
        <mat-slide-toggle class="custom-toggle mat-slide-custom" [(ngModel)]="isPrivate" color="primary"></mat-slide-toggle>
      </div>
      <span class="v3-moment-dialog__privacy-label">
        {{ 'translations.global.button.postPrivate' | transloco }}
      </span>
    </div>
  </div>

  <ptl-add-framework-tags
    *ngIf="frameworkTagsPanelOpen"
    [momentTags]="moment?.tags"
    [isDialogPage]="true"
    (closeFrameworkTags)="onToggleFrameworkTagsPanel($event)"
    (addTagBulk)="onAddTagBulk($event)"
  >
  </ptl-add-framework-tags>

  <div class="v3-moment-dialog__footer" *ngIf="!frameworkTagsPanelOpen">
    <div class="v3-moment-dialog__footer-left">
      <ptl-moment-add-tags
        [tags]="moment?.tags"
        [isVersion3]="true"
        (addTag)="onAddTag($event)"
        (openFrameworkTags)="onToggleFrameworkTagsPanel($event)"
        (removeTag)="onRemoveTag($event)"
      >
      </ptl-moment-add-tags>
    </div>

    <div class="v3-moment-dialog__footer-right">
      <button mat-button class="v3-moment-dialog__cancel-btn" (click)="onCancel()">
        {{ 'translations.global.button.cancel' | transloco }}
      </button>

      <button mat-flat-button color="primary" class="v3-moment-dialog__post-btn" [disabled]="!hasContent()" (click)="onPost()">
        {{ 'translations.global.button.post' | transloco }}
      </button>
    </div>
  </div>
</div>
